import { sql } from '../lib/db';
import { UserProfile } from '@/types/models';

interface AuthResponse {
  user: { id: string; email: string } | null;
  error: string | null;
}

interface SignUpData {
  email: string;
  password: string;
  fullName?: string;
  role?: 'admin' | 'mechanic' | 'customer';
  phone?: string;
}

export const authService = {
  // NOTE: This now requires an Auth provider like Auth.js or Clerk.
  // For now, these are placeholders that return errors as Supabase Auth is removed.
  async signIn(email: string, password: string): Promise<AuthResponse> {
    console.warn('SignIn: Auth provider required (e.g., Auth.js or Clerk)');
    return {
      user: null,
      error: 'Authentication provider not configured. Please set up Auth.js or Clerk for Vercel Postgres integration.'
    };
  },

  async signUp(data: SignUpData): Promise<AuthResponse> {
    console.warn('SignUp: Auth provider required');
    return {
      user: null,
      error: 'Authentication provider not configured.'
    };
  },

  async signOut(): Promise<{ error: string | null }> {
    return { error: null };
  },

  async getSession() {
    return { session: null, error: null };
  },

  async getUserProfile(userId: string): Promise<{ profile: UserProfile | null; error: string | null }> {
    try {
      const { rows } = await sql`
        SELECT * FROM user_profiles WHERE id = ${userId}
      `;

      if (rows.length === 0) {
        return { profile: null, error: 'Profile not found' };
      }

      const data = rows[0];
      const profile: UserProfile = {
        id: data.id,
        email: data.email,
        fullName: data.full_name,
        role: data.role,
        phone: data.phone,
        avatarUrl: data.avatar_url,
        createdAt: data.created_at,
        updatedAt: data.updated_at
      };

      return { profile, error: null };
    } catch (err) {
      return {
        profile: null,
        error: err instanceof Error ? err.message : 'Failed to fetch profile'
      };
    }
  }
};